import { hasRequired } from '@app/features/apply-react-signing/libs/fieldTypeGuards';
import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS,
  CONTRACT_PROGRESS_FIELD_FIRST_FOCUS,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressIsNeedFirstFocusState = boolean;

const initialState: ContractProgressIsNeedFirstFocusState = true;

export default function reducer(
  state: ContractProgressIsNeedFirstFocusState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS: {
      const { fields } = action.payload;
      const requiredFields = fields.filter(
        (field) => hasRequired(field.config) && field.config.required
      );

      return requiredFields.length > 0;
    }
    case CONTRACT_PROGRESS_FIELD_FIRST_FOCUS:
      return false;
    default:
      return state;
  }
}
